import React, { createContext, ReactNode, useContext, useMemo } from 'react'

type AppModeContextInitialValue = {
  isThin: boolean | string
}

const AppModeContext = createContext<AppModeContextInitialValue>({
  isThin: false,
})

// eslint-disable-next-line react-refresh/only-export-components
export const useAppModeContext = () => useContext(AppModeContext)

type AppModeProviderProps = {
  children: ReactNode
}

const AppModeContextProvider = ({ children }: AppModeProviderProps) => {
  const isThin =
    new URLSearchParams(window.location.search).get('thin') || false

  const contextProviderValue = useMemo(
    () => ({
      isThin,
    }),
    [isThin]
  )

  return (
    <AppModeContext.Provider value={contextProviderValue}>
      {children}
    </AppModeContext.Provider>
  )
}

export default AppModeContextProvider
